import React from "react";

import type { StreamLink } from "./StreamSetting.types";

interface SeeMoreLinksModalProps {
  links: StreamLink[];
  onClose: () => void;
}

const getLinkLabel = (item: StreamLink) => {
  const type = item.linkFor || item.type;

  if (type === "facebook") return "Facebook Stream";
  if (type === "youtube") return "YouTube Stream";

  return "Custom Stream";
};

const SeeMoreLinksModal: React.FC<SeeMoreLinksModalProps> = ({
  links,
  onClose,
}) => {
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-lg rounded-xl shadow-xl p-6 max-h-[85vh] overflow-y-auto">
        <h3 className="text-lg font-semibold mb-4">All Stream Links</h3>

        <div className="space-y-4">
          {links.map((item, index) => (
            <div key={index} className="border p-4 rounded-lg bg-gray-50">
              <p className="font-medium text-sm mb-2">{getLinkLabel(item)}</p>

              <div className="text-sm">
                <p className="text-blue-600 break-all">
                  <span className="font-semibold">Link: </span>
                  {item.link}
                </p>
                <p className="text-gray-700 break-all">
                  <span className="font-semibold">Key: </span>
                  {item.key}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gray-700 text-white rounded-lg hover:bg-gray-800"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SeeMoreLinksModal;
